import {Coordinate} from '~/shared/components/Maps/types';

// tel aviv
export const INITIAL_MAP_CENTER: Coordinate = {latitude: 32.0705562401733, longitude: 34.781744504583};

export const INITIAL_MAP_ZOOM = 10;

export const DEFAULT_MAX_ZOOM = 15;
